import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceKeywords'
})

export class ReplaceKeywordsPipe implements PipeTransform {
    transform(value: any, keywordsMap: { [key: string]: string; }): any {
        if (value != null) {
            if (typeof value == 'string') {
                return this.replaceText(value, keywordsMap);
            } else if (value.text) {
                return {
                  ...value,
                  text: Object.entries(keywordsMap)
                    .reduce((text, [keyword, replace]) => {
                      return this.replaceKeywordInText(text, keyword, replace);
                    }, value.text)
                };
            }
        }
        return value;
    }

    private replaceText(text: string, keywordsMap: { [key: string]: string; }): string {
        if (text == null || text == '') {
          return text;
        } else {
          return Object.entries(keywordsMap)
            .reduce((text, [keyword, replace]) => {
              return this.replaceKeywordInText(text, keyword, replace);
            }, text);
        }
    }

    private replaceKeywordInText(text: string, keyword: string, replace: string): string {
        // new RegExp es careli, podría preprocesarse el keywordsMap
        const regex = new RegExp(`\\$\\{${keyword}\\}`, 'g');
        return text.replace(regex, replace);
    }
}